import { Box, Chip, Paper, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ELinks } from '@sharedInterfaces/globalEnums';
import type Employee from '@src/Objects/Employee';
import { Briefcase } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ProjectExperienceWidgetProps {
    employee: Employee;
}

function ProjectExperienceWidget({ employee }: ProjectExperienceWidgetProps) {
    const theme = useTheme();
    const navigate = useNavigate();

    const projects = [...(employee.projects || [])].filter((p) => p.active).slice(0, 3);

    return (
        <Paper
            elevation={0}
            sx={{
                p: { lg: 3, md: 2, xs: 2 },
                border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                borderRadius: 2,
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                Aktuelle Projekte
            </Typography>

            {projects.length === 0 ? (
                <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                    Noch keine Projekte vorhanden
                </Typography>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    {projects.map((project) => (
                        <Box
                            key={project.id}
                            sx={{
                                pl: 2,
                                borderLeft: `3px solid ${theme.palette.primary.main}`,
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    borderLeftColor: theme.palette.primary.dark,
                                    pl: 2.5,
                                },
                            }}
                            onClick={() => navigate(`/${ELinks.SALES_PROJECTS}/${project.id}`)}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 0.5 }}>
                                <Briefcase size={16} color={theme.palette.primary.main} style={{ marginTop: 2 }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    {project.title}
                                </Typography>
                            </Box>
                            {project.business && (
                                <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 1 }}>
                                    {project.business.title}
                                </Typography>
                            )}
                        </Box>
                    ))}
                </Box>
            )}
        </Paper>
    );
}

export default ProjectExperienceWidget;
